
export const ip = '3.82.186.14:8000';
export const mainURL = `http://${ip}/`;


